<div ng-controller="stageConfigController as stageConfigCtrl">
    <div c-toggle="stageConfigCtrl.show" c-toggle-type="fade">
        <c-auto-form config="stageConfigCtrl.autoFormConfig" class="stage-config-view"></c-auto-form>
    </div>
</div>